<div class="logo-box">
    <h1 style="border-bottom: 5px solid #e9a921">
        <a href="">
            {{settings?.Name || "Apostille"}}<small>{{settings?.TLD || "com"}}</small> 
        </a>
    </h1>
    <i style="font-family: sans-serif">
        <small style="font-size: 0.75em">
            Authorized and Supported by United States Apostille
        </small>
    </i>

</div>
<div class="background-img p-0">
    <img [src]="settings?.countryImg || 'assets/imgs/mexico.png'" width="100%" [alt]="settings?.CountryName  ||'Country'" class="country-lco">
</div>